module.exports = __webpack_public_path__ + "img/tester_01.4712e669.jpg";